import { Injectable } from '@angular/core';
import { Product } from '../models/product.model';
import { Carro } from '../models/carro.model';
import { Platform } from '@ionic/angular';
import { parametros } from '../models/parametros.model';
import { Category } from '../models/category.model';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { listaCarros } from '../models/listaCarros';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalService
{

    public AppId: string;// = 'es.overlay.chapela';
    public titulo: string;// = 'Chapela Ceuta Distrubución';
    public telefono: string;// = '956 52 23 06';
    public email: string;// = 'chapelaceuta@chapelaceuta.es';
    public actualizo: boolean = false;


    public versionAPI = "";
    public version = '1.0.13.05';


    apiRUL: any;
    constructor(private platform: Platform,
        private nativeStorage: NativeStorage,
        private configServ: ConfigService)
    {
        //this.host = 'https://covadul.site/overapi';
        //this.host = 'https://overlaysistemas.com/overapi2';
        //this.host = 'https://universosnack.com/overapi';

        //this.host = 'https://manjaral.com/overapi';
        //this.host = 'http://192.168.0.224:8888/slim4'; // Vioque local tests
        //this.host = 'https://monforte.shop/Admin_sinc2/overapi2';
        //this.host = 'http://192.168.0.236:8000/Admin_sinc2/overapi2';
        //this.host = 'https://distribucionesgoyo.es/Admin_sinc2/overapi2';
        //this.host =  'https://salom.overlink.es/Admin_sinc2/overapi2';
        //this.host = 'https://exclusivaspeco.overlink.es/Admin_sinc2/overapi2';
        //this.host = 'https://casalma.overlink.es/Admin_sinc2/overapi2';
        //this.host = 'https://adame.overlink.es/Admin_sinc2/overapi2';
        //this.host = 'https://overlay.overlink.es/Admin_sinc2/overapi2';
        //this.host =  'https://disantos.overlink.es/Admin_sinc2/overapi2';
        //this.host =  'https://esparcia.overlink.es/Admin_sinc2/overapi2';
        //this.host =  'https://losfuenteños.overlink.es/Admin_sinc2/overapi2';
        //this.host = 'https://alcruz.overlink.es/Admin_sinc2/overapi2';
        //this.host =  'https://monforte.overlink.es/Admin_sinc2/overapi2';
        //this.host = 'https://test.overlink.es/Admin_sinc2/overapi82';

        //this.host =  'https://chapela.ceuta.overlink.es/Admin_sinc2/overapi2';
        //this.AppId     = 'es.overlay.chapela';
        //this.titulo    = 'Chapela Ceuta Distrubución';
        //this.telefono  = '956 52 23 06';
        //this.email     = 'chapelaceuta@chapelaceuta.es';

        //this.host =  'https://chapela.ceuta.overlink.es/Admin_sinc2/overapi2';
        //this.AppId     = 'es.overlay.chapela';
        //this.titulo    = 'Chapela Ceuta Distrubución';
        //this.telefono  = '956 52 23 06';
        //this.email     = 'chapelaceuta@chapelaceuta.es';

        configServ.loadConfig().then((data) =>
        {

            this.apiRUL = data;
            this.host = this.apiRUL.apiUrl ? this.apiRUL.apiUrl : this.host;
            this.AppId = this.apiRUL.AppId ? this.apiRUL.AppId : this.AppId;
            this.titulo = this.apiRUL.titulo ? this.apiRUL.titulo : this.titulo;
            this.telefono = this.apiRUL.telefono ? this.apiRUL.telefono : this.telefono;
            this.email = this.apiRUL.email ? this.apiRUL.email : this.email;
            this.debug = this.apiRUL.logger ? this.apiRUL.logger : false;
        
            console.log( "Debug", this.debug );
        },
            (error) => { console.error("Sin config.json"); });

        

        this.esWeb = platform.is('desktop') || platform.is('mobileweb');

        this.nativeStorage.getItem('busquedaExactaPorCodigo')
            .then(
                data =>
                {
                    this.busquedaExactaPorCodigo = data;
                },
                error => { }
            );


    }

    // Host
    public host: string;

    public debug : boolean;

    // filtro categorias
    public filtroCat: string = '';


    // Titulo
    //public titulo: string = 'Emicela';

    //public titulo: string = 'Casalma S.L.';
    //public telefono: string = '673 73 72 79';Overlay2

    //public email: string = 'administracion4@casalma.com';

    //public AppId    : string = 'es.overlay.overlay';    
    //public AppId    : string = 'es.overlay.demo';
    //public titulo   : string = 'Overlay S.A.';
    //public telefono : string = '968 12 35 55';
    //public email    : string = 'info@overlay.es';

    //public AppId    : string = 'es.overlay.disantos';
    //public titulo   : string = 'Distribuciones Santos S.L.';
    //public telefono : string = '967 30 32 15';
    //public email    : string = 'pedidosdisantos@gmail.com';

    //public titulo: string = 'Esparcia Café';
    //public telefono : string = '';
    //public email    : string = '';

    //public titulo: string = 'Los Fuenteños';
    //public telefono : string = '620581009';
    //public email    : string = 'logistica.losfuentenos@gmail.com';

    //public titulo: string = 'Alcruz Canarias';
    //public telefono: string = '928821458';
    //public email: string = ' central@alcruzcanarias.com';

    //public titulo: string = 'Monforte Distribuciones 2016, S.L. ';
    //public telefono : string = '976169055';
    //public email    : string = 'buzon@monforte.es';


    //public titulo: string = 'ADAME quality service';
    //public telefono : string = '';
    //public email    : string = '';

    //public titulo: string = 'Exclusivas Peco';
    //public titulo: string = 'Manjaral';
    //public titulo: string = 'Monforte';
    //public titulo: string = 'Covadul';

    //public titulo: string = 'Overlay Software';
    //public telefono: string = '968 500 176';
    //public email: string = 'lcegarra@overlay.es';

    //public titulo: string = 'Distribuciones Alimenticias Salom';
    //public titulo: string = 'Esparcia Café';
    //public titulo: string = 'Distribuciones Goyo';
    //public titulo: string = 'Distribuciones Santos S.L.';

    public url = '';

    // List of product
    public products: Product[];

    // List of product
    public productsPref: Product[];

    // List of categories
    public categorias: Category[];

    // Lista de parametros
    public parametros: parametros;

    // Parametro 074
    public decimalesUnidades074: number;

    // Parametro 329
    public unidadMedidaMiniaturas329: number;

    // Parametro L03
    public solicitoFechaRepartoL03: boolean;

    // Parametro L04
    public ocultoUnidadNoDefectoL04: boolean;

    // Parametro L05
    public textoImpuestosL05: string;

    // Parametro L06
    public carritoSumaUnidadesL06: boolean = false;

    // Parametro L07
    public usoAnotacionesDocumentosL07: boolean = false;

    // Parametro L06
    public codigoIncidenciaAnotacionesL08: string;

    // Parametro L09
    public multiplesCarritosL09: boolean = false;

    public mostrarArticulosConPrecioCeroL13: boolean = false;
   
    public textoPrecioCeroL15: string = "";

    public esconderBotonesMiniaturasVtasL17: boolean = false;

    public listaDeCarritos: listaCarros[];

    // Parametro 519
    public diasAvanceFechaReparto519: string;

    //Fecha Reparto ( L03 y 519 )
    public fechaReparto: Date = null;

    // Filtro
    public opciones: any = null;

    // productos del carro
    public cartProducts: Carro;


    public idCarritoActivo: string = '1';
    public descripCarritoActivo: string = '';

    // categoria de productos activa
    public catProducts: string;

    // nombre categoria de productos activa
    public catName: string;

    // Lista de productos del historico
    public historico: Product[];

    // Lista de productos deseados
    public whislist: Product[];

    //control de cambio
    public cambio = false;

    //control de carga
    public cargando = false;

    public searchTerm: string = "";

    public isOptionSearchOpen: boolean = false;

    public textoComoBusco: string = "Buscar productos";

    //control de cambio
    public token = '';

    //identificador de máquina
    public deviceID = '';

    public esWeb: boolean;

    //articulos en el carro
    public artcart = 0;

    //articulos en el carro
    public mensajesSinLeer = 0;

    public busquedaExactaPorCodigo = false;

    //Articulo al chat
    public itemChat;

    public usuarioId = '';

    public cliente = '';

    public grupo = '';

    public usuario = '';

    public password = '';

    public muestroPreciosCliente: boolean = true;

    //Tengo precio para el artículo
    articuloDistintoPrecioCeroL13(_item)
    {
        //Si no permito mostrar artículos con precio cero, la API directamente no los devuelve, 
        // por lo que si no esta el parametro activo.... si muestro porq seguro que tiene
        if( !this.mostrarArticulosConPrecioCeroL13 ) return true;

        // Si el L13 esta activo, puede que haya sin precio
        if (_item.tarifa)
        {
            // Muestro precio para tarifas de tipo 0 ( del cliente ) 1 ( de la direccion de envio ) 2 ( defecto L13 )
            //Si el tipo es 4, es que no tiene precio
            return (_item.tarifa.tipoTarifa < "3");
        }
        return false;
    }

    //Muestro los botones de cantidad..
    muestroBotonesCantidadEnMiniatura(_item)
    {
        //... si el articulo tiene precio y no escondo los botones en las miniaturas
        return ((this.articuloDistintoPrecioCeroL13(_item)) && (!this.esconderBotonesMiniaturasVtasL17));
    }

    // Me indica si muestro precios
    muestroPrecios(_item)
    {
        //Si he marcado no mostras al cliente, no muestro nada
        if (!this.muestroPreciosCliente) return false;     
        
        //Si el cliente si se le muestran precios, verifico que para este artículo si tenga precio
        return this.articuloDistintoPrecioCeroL13(_item);
    }

    rellenarCeros(cadena: string, longitud: number): string
    {
        if (cadena.length >= longitud)
        {
            return cadena;
        } else
        {
            const cerosFaltantes = longitud - cadena.length;
            const ceros = '0'.repeat(cerosFaltantes);
            return ceros + cadena;
        }
    }

    showHidenOpciones()
    {
        this.isOptionSearchOpen = !this.isOptionSearchOpen;
    }

    busquedaPorCodigo()
    {
        this.searchTerm = '';
        this.textoComoBusco = "Buscar por código";
        this.isOptionSearchOpen = false; // Oculta el menú después de hacer clic en la opción
        this.busquedaExactaPorCodigo = true;
        this.nativeStorage.setItem('busquedaExactaPorCodigo', this.busquedaExactaPorCodigo);
    }

    busquedaPorContenida()
    {
        // Lógica para la opción 2

        this.searchTerm = '';
        this.textoComoBusco = "Buscar productos";
        this.isOptionSearchOpen = false; // Oculta el menú después de hacer clic en la opción
        this.busquedaExactaPorCodigo = false;
        this.nativeStorage.setItem('busquedaExactaPorCodigo', this.busquedaExactaPorCodigo);
    }

    stringToNumero(cadena: string): number
    {
        if (!cadena) return 0;

        let s = cadena
            .trim()
            .replace(/\s/g, '')
            .replace(/[€$%]/g, '');

        if (!s) return 0;

        const tieneComa = s.includes(',');
        const tienePunto = s.includes('.');

        if (tieneComa && tienePunto)
        {
            // El último separador manda (decimal)
            if (s.lastIndexOf(',') > s.lastIndexOf('.'))
            {
                // 1.234,56 -> 1234.56
                s = s.replace(/\./g, '').replace(',', '.');
            } else
            {
                // 1,234.56 -> 1234.56
                s = s.replace(/,/g, '');
            }
        } else if (tieneComa)
        {
            // 12,5 -> 12.5
            // 1,234,567 -> 1234567
            const comas = (s.match(/,/g) || []).length;
            s = comas > 1 ? s.replace(/,/g, '') : s.replace(',', '.');
        } else if (tienePunto)
        {
            // 1.234.567 -> 1234567
            const puntos = (s.match(/\./g) || []).length;
            if (puntos > 1) s = s.replace(/\./g, '');
        }

        const n = Number(s);
        return Number.isFinite(n) ? n : 0;
    }

}
